import React, { useEffect } from "react";
import { Box, Button, Chip } from "@mui/material";
import logo from "../../../assets/images/stream.png";
import { useSearchParams } from "react-router-dom";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import styles from "./meeting.module.css";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import { useMediaQuery, useTheme } from "@mui/material";
import useNotificationProvider from "hooks/notificationBar/useNotificationProvider";

function Meeting() {
  const [searchParams] = useSearchParams();
  const roomUrl = searchParams.get("roomUrl") || "";
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.up("md"));
  const { notifySuccess, notifyError } = useNotificationProvider();

  useEffect(() => {
    const scriptId = "whereby-embed-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://cdn.srv.whereby.com/embed/v2-embed.js";
      script.type = "module";
      document.body.appendChild(script);
    }
  }, []);

  if (!roomUrl) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        Invalid meeting link
      </Box>
    );
  }

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      notifySuccess("Meeting link copied to clipboard!");
    } catch (err) {
      console.error("[Meeting] Failed to copy link:", err);
      notifyError("Failed to copy meeting link");
    }
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          margin: 0,
          padding: 0,
          overflow: "hidden",
        }}
      >
        <whereby-embed
          room={roomUrl}
          style={{ width: "100%", height: "100%" }}
        />
      </Box>

      {/* Floating Return Button */}
      <div className={styles.floatingReturn}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => window.history.back()}
        >
          <KeyboardReturnIcon sx={{ mr: isMedium ? 1 : 0 }} />
          {isMedium && "Return"}
        </Button>
      </div>

      {/* Floating Stream Data Systems Chip */}
      {isMedium && (
        <Chip
          label="Powered by Stream Data Systems"
          variant="outlined"
          className={styles.floatingChip}
          icon={
            <Box
              component="img"
              src={logo}
              alt="logo"
              sx={{ width: 20, height: 20 }}
            />
          }
        />
      )}

      {/* Floating Copy Meeting Link Button */}
      <div className={styles.floatingCopyLink}>
        <Button variant="outlined" color="primary" onClick={handleClick}>
          <ContentCopyIcon sx={{ mr: isMedium ? 1 : 0 }} />
          {isMedium && "Copy Meeting Link"}
        </Button>
      </div>
    </>
  );
}

export default Meeting;
